<span
  class="ktbl-sub-table-header-base ktbl-sub-table-header-background-einzel ktbl-typografie-reg-14-zwischenueberschrift"
>
  {{ modulPrWertFilter.modul }}
</span>

<div class="ktbl-row-mehrspaltig-2-elemente">
  <mat-form-field appearance="fill" class="ktbl-input-box">
    <mat-label>Von</mat-label>
    <mat-select
      disableRipple
      (selectionChange)="onChangeVon()"
      [formControl]="selectValueVonFormControl"
    >
      <mat-option
        *ngFor="let entry of modulPrWertFilter.wertPrFilterVonList"
        [value]="entry.wert"
      >
        {{ valueFormat.getStringDecimal(entry.wert, entry.nachkommastellen) }}
        {{ entry.dimension }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="selectValueVonFormControl.hasError('pattern')">
      Der "Von"-Wert darf nicht größer als der "Bis"-Wert sein.
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="ktbl-input-box">
    <mat-label>Bis</mat-label>
    <mat-select
      disableRipple
      (selectionChange)="onChangeBis()"
      [formControl]="selectValueBisFormControl"
    >
      <mat-option
        *ngFor="let entry of modulPrWertFilter.wertPrFilterBisList"
        [value]="entry.wert"
      >
        {{ valueFormat.getStringDecimal(entry.wert, entry.nachkommastellen) }}
        {{ entry.dimension }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="selectValueBisFormControl.hasError('pattern')">
      Der "Bis"-Wert darf nicht kleiner als der "Von"-Wert sein.
    </mat-error>
  </mat-form-field>
</div>
